import EDC from '@/components/games/shared/globals';
import router from '@/router/index';
import store from '@/store/index';
import CursorManager from '@/components/games/shared/cursor-manager';
import { isBetaWebsite } from '@/helpers/env-detect';
import { openInNewTab } from '@/helpers/links-helpers';

/**
 *
 */
EDC.Games.TitleMenu.Scenes.Main = function () {
  this.menuScene = null;
  this.cursorManager = null;
};

const titleMenu = EDC.Games.TitleMenu.Scenes.Main.prototype;

titleMenu.init = function () {
  this.bg = null;
  this.menuBg = null;
  this.content = null;
  this.cursorManager = null;
  this.logo = null;
  const activeAccount = store.getters['children/activeChildProfile'];
  if (activeAccount) {
    this.scale.off('resize', this.resizeActive, this);
  } else {
    this.scale.off('resize', this.resizeInactive, this);
  }
};

titleMenu.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);
  this.scene.launch('TitleMenu-Menu');
  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'background');
  this.menuScene = this.scene.get('TitleMenu-Menu');
  this.menuScene.menuEvents.on('EVT_MENU_CREATED', this.addMenuButtons, this);
};
/**
 *
 */
titleMenu.addMenuButtons = function () {
  this.menuScene.getMenuBg().destroy();
  this.menuBg = this.add.sprite(0, 0, 'menu-bg');
  this.menuBg.init_scale = 0.9;
  this.menuBg.setPosition(0, 0);
  this.content = this.add.container();
  const activeAccount = store.getters['children/activeChildProfile'];
  let parentBtn = null;

  if (activeAccount) {
    const playBtn = this.menuScene.addButton('play', this.onPlay.bind(this));
    const switchBtn = this.menuScene.addButton('switch', this.onSwitch.bind(this), null, null, 180);
    parentBtn = this.menuScene.addButton('parent', this.onParentSite.bind(this), null, null, 180);

    this.cursorManager.setDefaultDraggableEvents(playBtn);
    this.cursorManager.setDefaultDraggableEvents(switchBtn);
    this.content.add([playBtn, switchBtn, parentBtn]);
    this.scale.on('resize', this.resizeActive, this);

    parentBtn.x -= 300;
    switchBtn.x -= 300;
    playBtn.x -= 300;

    this.resizeActive({ width: this.scale.width, height: this.scale.height });
  } else {
    const newPlayerBtn = this.menuScene.addButton('new-player', this.onNewGame.bind(this));
    const linkPlayerBtn = this.menuScene.addButton('link-player', this.onSwitch.bind(this));
    parentBtn = this.menuScene.addButton('parent', this.onParentSite.bind(this));

    newPlayerBtn.x -= 300;
    linkPlayerBtn.x -= 300;
    parentBtn.x -= 300;
    this.cursorManager.setDefaultDraggableEvents(newPlayerBtn);
    this.cursorManager.setDefaultDraggableEvents(linkPlayerBtn);
    this.content.add([newPlayerBtn, linkPlayerBtn, parentBtn]);
    this.scale.on('resize', this.resizeInactive, this);
    this.resizeInactive({ width: this.scale.width, height: this.scale.height });
  }
  this.cursorManager.setDefaultDraggableEvents(parentBtn);
};
/**
 *
 */
titleMenu.onNewGame = function () {
  router.push({ name: 'newgame' });
};
/**
 *
 */
titleMenu.onPlay = function () {
  router.push({ name: 'welcome-back' });
};
/**
 *
 */
titleMenu.onSwitch = function () {
  router.push({ name: 'switch-child' });
};
/**
 *
 */
titleMenu.onParentSite = function () {
  const href = isBetaWebsite() ? 'https://beta.growmindgrow.com' : 'https://growmindgrow.com';
  openInNewTab(href);
};

titleMenu.resizeActive = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;
  this.cameras.resize(width, height);
  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);
  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.57) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition(
    (width - bounds.width) / 2 + 200 * neededScale,
    height / 2 - bounds.height + 600 * neededScale,
  );
  this.menuBg.setScale(this.menuBg.init_scale * neededScale);
  this.menuBg.setPosition(this.content.x + bounds.width / 2 - 195 * neededScale,
    this.content.y + 15 * neededScale);

  this.content.x = this.menuBg.x + 300 * neededScale;
};

titleMenu.resizeInactive = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;
  this.cameras.resize(width, height);
  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);
  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.4) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition(
    (width - bounds.width) / 2 + 200 * neededScale,
    height / 2 - bounds.height + 430 * neededScale,
  );
  this.menuBg.setScale(this.menuBg.init_scale * neededScale);
  this.menuBg.setPosition(this.content.x + bounds.width / 2 - 192 * neededScale,
    this.content.y + 5 * neededScale);

  this.content.x = this.menuBg.x + 300 * neededScale;
};

export default EDC.Games.TitleMenu.Scenes.Main;
